import { render, staticRenderFns } from "./grades-report.vue?vue&type=template&id=6a095997&scoped=true"
import script from "./grades-report.vue?vue&type=script&lang=ts"
export * from "./grades-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a095997",
  null
  
)

export default component.exports